import { extendTheme } from "@chakra-ui/react";
import { theme as baseTheme } from "@saas-ui-pro/react";

const colors = {
  primary: {
    50: "#f7fdfb",
    100: "#d2f2e7",
    200: "#9fe3cd",
    300: "#64d2ad",
    400: "#1dbd88",
    500: "#0ea371",
    600: "#0c875e",
    700: "#096949",
    800: "#07563c",
    900: "#064731",
  },
};

const _disabled = {
  opacity: 1,
};

const components = {
  SuiSelect: {
    baseStyle: {
      field: {
        _disabled,
      },
    },
  },
  Input: {
    baseStyle: {
      field: {
        _disabled,
      },
    },
  },
  FormLabel: {
    baseStyle: {
      _disabled,
    },
  },
  Textarea: {
    baseStyle: {
      _disabled,
    },
  },
  NumberInput: {
    baseStyle: (props: any) => {
      const styles = (baseTheme.components.NumberInput.baseStyle as any)(props);
      return {
        ...styles,
        field: {
          ...styles.field,
          _disabled,
        },
      };
    },
  },
  Checkbox: {
    baseStyle: (props: any) => {
      const styles = (baseTheme.components.Checkbox.baseStyle as any)(props);
      return {
        ...styles,
        label: {
          ...styles.label,
          _disabled,
        },
      };
    },
  },
};

export const theme = extendTheme({ colors, components }, baseTheme);
